import { getErrorString } from '../../utility/utility';

import actions from './actions';

const {
  SET_LEAD_LISTINGS_TABLE_DATA,
  SET_SELECTED_USER,
  LEADS_BREAKDOWN_DATA_BEGIN,
  LEADS_BREAKDOWN_DATA_ERROR,
  LEADS_BREAKDOWN_DATA_SUCCESS,
  SET_LEADS_BREAKDOWN_FILTERS,
} = actions;

const initialState = {
  leadsBreakdownData: { data: null, loading: true, error: null, filterObj: {} },
  leadListingsTable: {
    table: [],
    list: [],
    loading: true,
    error: null,
  },
  selectedUser: {},
};

const LeadsDashboardReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SET_SELECTED_USER:
      return {
        ...state,
        selectedUser: { ...payload },
      };
    case SET_LEAD_LISTINGS_TABLE_DATA:
      return { ...state, leadListingsTable: { ...state.leadListingsTable, ...payload } };
    case LEADS_BREAKDOWN_DATA_BEGIN:
      return {
        ...state,
        leadsBreakdownData: {
          ...state.leadsBreakdownData,
          ...payload,
        },
      };
    case LEADS_BREAKDOWN_DATA_ERROR:
      return {
        ...state,
        leadsBreakdownData: {
          ...state.leadsBreakdownData,
          ...payload,
        },
      };
    case LEADS_BREAKDOWN_DATA_SUCCESS:
      return {
        ...state,
        leadsBreakdownData: {
          ...state.leadsBreakdownData,
          ...payload,
        },
      };
    case SET_LEADS_BREAKDOWN_FILTERS:
      const filterObj = state.leadsBreakdownData?.filterObj;
      return {
        ...state,
        leadsBreakdownData: {
          ...state.leadsBreakdownData,
          filterObj: {
            ...filterObj,
            ...payload,
          },
        },
      };
    default:
      return state;
  }
};
export { LeadsDashboardReducer };
